export const checkIsHiddenByFF = ({ FF, isFFNegative, featureFlags }) => {
  if (!FF) {
    return false;
  }

  return isFFNegative ? featureFlags[FF] : !featureFlags[FF];
};
